
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Ţintuire',
	'find_label': 'Găsire',
	'findCancelLabel': 'Anulare',
	'dataPaneLabel': 'Date',
	'sourcePaneLabel': 'Surse selectate',
	'sourcePaneContentLabel': 'Selectarea unei surse',
	'emptySourcePaneTitle': 'Selectarea unei surse',
	'emptySourcePaneCaption': 'Faceţi clic pentru a selecta o sursă pentru a adăuga datele de utilizat pentru construirea unui tablou de bord. ',
	'addDataSource': 'Selectarea unei surse',
	'addDataDashboardCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date pe tabloul dumneavoastră de bord.',
	'addDataStoryCoachMarkContents': 'Trageţi şi plasaţi date din panoul de date în povestea dumneavoastră.',
	'addDataCoachMarkTitle': 'Adăugare date',
	'selectSourcesText': 'Selectaţi şi adăugaţi o sursă de date pentru a construi propria %{app}. ',
	'selectSourcesLabel': 'Selectarea unei surse',
	'errorSourcesTitle': 'A eşuat încărcarea arborelui de date',
	'errorLoadingDataSources': 'A apărut o eroare la încărcarea listei de seturi de date',
	'errorLoadingDataTree': 'A apărut o eroare la încărcarea arborelui',
	'dataSetPaneLastUpdated': 'Ultima actualizare: %{date}',
	'dataSourcePaneDateUnknown': 'Necunoscut',
	'moreTitle': 'Mai multe',
	'backLabel': 'Deplasare înapoi',
	'addDataSourceDialogTitle': 'Selectarea unei surse',
	'addDataSourceDialogButtonLabel': 'Adăugare',
	'dlg_use': 'Utilizare',
	'dlg_RelinkDataSourceTitle': 'Înlocuiţi setul de date "%{dataSourceName}" cu ...',
	'propertiesDialogTitle': 'Proprietăţi',
	'loadingMetadata': 'Încărcare metadate',
	'missingDataSetData': 'Datele pentru acest set de date nu sunt disponibile. Reîmprospătaţi setul de date sau contactaţi-vă administratorul pentru accesul la sursă.',
	'errorLoadingSource': 'The metadata for "%{sourceName}" did not load. Vă rugăm să vă contactaţi administratorul pentru detalii.',
	'errorMessageTitle': 'Eroare',
	'calculation_navigation_in_use': 'Deleting calculations, filters or navigation paths invalidates all visualizations that reference the deleted item. Sunteţi sigur că vreţi să ştergeţi?',
	'delete_confirm': 'Confirmare ştergere',
	'previewUnavailable': 'Tava de date şi filtrele globale nu sunt disponibile pentru acest tip de pachet.',
	'contextualGridTabName': 'Date vizualizare',
	'DATA_TRAY_no_data_text': 'Nu aveţi momentan nicio dată',
	'contextualGridMenuLabel': 'Meniu de date vizualizare',
	'contextualGridExport': 'Export',
	'nullValueText': 'Nul',
	'forecastDetailsTabName': 'Detalii statistice previziune',
	'forecastDetailsModelLabel': 'Model',
	'forecastDetailsQualityMetricLabel': 'Măsuri acurateţe',
	'forecastDetailsSmoothingCoefLabel': 'Parametri',
	'forecastDetailsDiagnostics': 'Diagnostice',
	'forecastDetailsForecastLabel': 'Previziune',
	'forecastDetailsStatusLabel': 'Stare',
	'forecastDetailsAccuracyPercentLabel': 'Acurateţe %',
	'forecastDetailsTrendLabel': 'Tendinţă',
	'forecastDetailsSeasonLabel': 'Sezonabilitate',
	'forecastDetailsSeasonalPeriodLabel': 'Perioadă sezonieră',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Phi',
	'forecastDetailsMissingCount': 'Conţinut lipsă',
	'forecastDetailsSeriesLengthLabel': 'Lungime serie',
	'forecastDetailsIgnoredPeriods': 'Perioade ignorate',
	'forecastDetailsTrendStrength': 'Putere tendinţă',
	'forecastDetailsSeasonalityStrength': 'Putere sezonabilitate',
	'forecastDetailsTimeDeltaUnit': 'Interval dată / oră',
	'forecastDetailsNotes': 'Note'
});
